import React from 'react';
import {View, Text, StyleSheet} from 'react-native';
import TrustTag from '../TrustTag';

const InfoBar = ({trust, value, status, statusText}) => {
  const content = [];

  if (trust) {
    content.push(<TrustTag key={trust} trust={trust} />);
  }

  if (trust && value) {
    content.push(
      <Text key="divider-1" style={infoStyles.infoBarDivider}>{`\u2022`}</Text>,
    );
  }

  if (value) {
    content.push(
      <Text key="value" style={infoStyles.infoBarValue}>{`${value}`}</Text>,
    );
  }

  if (value && status !== undefined && statusText) {
    content.push(
      <Text key="divider-2" style={infoStyles.infoBarDivider}>{`\u2022`}</Text>,
    );
  }

  if (status !== undefined && statusText) {
    content.push(
      <Text
        key="status"
        style={[infoStyles.infoBarValue, !status && {color: '#ED242B'}]}>
        {statusText}
      </Text>,
    );
  }

  return <View style={infoStyles.infoBar}>{content}</View>;
};

const infoStyles = StyleSheet.create({
  infoBar: {
    paddingBottom: 16,
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  infoBarValue: {
    fontSize: 12,
    color: '#798B93',
    fontWeight: '500',
    lineHeight: 15,
  },
  infoBarDivider: {
    paddingHorizontal: 4,
    fontSize: 12,
    color: '#798B93',
    fontWeight: '500',
    lineHeight: 15,
  },
});

export default InfoBar;
